import React from "react";

import { CloseOutlined } from "@ant-design/icons";

import { ReactComponent as CalendarIcon } from "../../../../assets/icons/Sample Submission Redesign/calendar-todo-line.svg";
import { ReactComponent as ListCheckIcon } from "../../../../assets/icons/Sample Submission Redesign/list-check.svg";
import { ReactComponent as SearchScopeIcon } from "../../../../assets/icons/Sample Submission Redesign/search-line.svg";
import { ReactComponent as UserIcon } from "../../../../assets/icons/Sample Submission Redesign/sound-module-line.svg";
import { ReactComponent as TubeIcon } from "../../../../assets/icons/Sample Submission Redesign/test-tube-line.svg";
import { ReactComponent as DeleteByIcon } from "../../../../assets/images/sample-submission/DeleteByIcon.svg";

import "./SubmissionsFilterTags.css";

const TAG_ICONS = {
  status: ListCheckIcon,
  category: TubeIcon,
  issues: ListCheckIcon,
  deleted: DeleteByIcon,
  date: CalendarIcon,
  submittedBy: UserIcon,
  searchBy: SearchScopeIcon,
};

export default function SubmissionsFilterTags({
  tags = [],
  onRemoveTag,
  onClearAll,
}) {
  if (!tags.length) return null;

  return (
    <div className="SubmissionsFilterTags">
      <div className="SubmissionsFilterTags__List">
        {tags.map((tag) => {
          const Icon = TAG_ICONS[tag.iconType] || ListCheckIcon;
          return (
            <span key={tag.id} className="SubmissionsFilterTags__Tag">
              <Icon className="SubmissionsFilterTags__TagIcon" aria-hidden />
              <span className="SubmissionsFilterTags__TagLabel">{tag.label}</span>
              <button
                type="button"
                className="SubmissionsFilterTags__RemoveBtn"
                aria-label={`Remove ${tag.label} filter`}
                onClick={() => onRemoveTag(tag.id)}
              >
                <CloseOutlined />
              </button>
            </span>
          );
        })}
      </div>
      <button
        type="button"
        className="SubmissionsFilterTags__ClearAll"
        onClick={onClearAll}
      >
        Clear all
      </button>
    </div>
  );
}
